import React from 'react';
import PropTypes from 'prop-types';

const ToggleButtonGroup = ({ options = [], value, onChange }) => {
  return (
    <div className="cluster-1 rounded-full bg-neutral-400 p-1">
      {options.map((option) => {
        const isActive = value === option.value;
        const Icon = option.icon;

        return (
          <button
            data-testid={`button-toggle-option-${option.value}`}
            type="button"
            key={option.value}
            onClick={() => onChange(option.value)}
            className={`flex-1 cluster-2 items-center justify-center px-4 py-2 rounded-full text-sm transition-colors
                ${isActive ? 'bg-surface' : 'hover:bg-surface'}`}
          >
            {Icon && <Icon className="h-5 w-5" />}
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};

ToggleButtonGroup.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.elementType,
    }),
  ).isRequired,
};

export default ToggleButtonGroup;
